import React from 'react';

class QueryStats extends React.Component{
    estimatedRuntime() {
      const toWords = {
        0: "Under a minute",
        1: "Minutes",
        2: "Hours",
        3: "Days",
        4: "Potentially never"
      }

      return toWords[this.estimatedComplexityClass()];
    }

    estimationIcon() {
      const icons = {
        0: "fa-solid fa-thumbs-up",
        1: "fa-solid fa-thumbs-up",
        2: "fa-solid fa-hourglass",
        3: "fa-solid fa-circle-exclamation text-seqorange",
        4: "fa-solid fa-triangle-exclamation text-seqorange"
      }

      return icons[this.estimatedComplexityClass()];
    }

    estimatedComplexityClass() {
      const naiveComplexity = this.props.residuesInQuerySequence * this.props.residuesInSelectedDbs;

      if (naiveComplexity < 1e12) {
        return 0;
      } else if (naiveComplexity < 1e14) {
        return 1;
      } else if (naiveComplexity < 1e16) {
        return 2;
      } else if (naiveComplexity < 1e18) {
        return 3;
      } else {
        return 4;
      }
    }

    componentShouldRender() {
      return this.props.residuesInQuerySequence > 0 && this.props.numberOfDatabasesSelected > 0
    }

    render () {
      if (!this.componentShouldRender()) {
        return null;
      }

      return <div className={`flex-grow grid grid-cols-1 md:grid-cols-3 gap-4 md:divide-x md:divide-y-0 divide-y}`}>
          <div className="hidden h-50 md:flex w-auto flex-col justify-center items-start">
            <p className="text-xs font-dm font-medium text-gray-600">Residues in Query</p>
            <h4 className="text-sm font-bold text-gray-700">{this.props.residuesInQuerySequence.toLocaleString()}</h4>
          </div>

          <div className="hidden h-50 md:flex w-auto flex-col justify-center items-start pt-4 md:pl-2 md:pt-0">
            <p className="text-xs font-dm font-medium text-gray-600">Residues in Selected Databases</p>
            <h4 className="text-sm font-bold text-gray-700">{this.props.residuesInSelectedDbs.toLocaleString()}</h4>
          </div>

          <div className="h-50 flex w-auto flex-col justify-center items-start pt-4 md:pl-2 md:pt-0">
            <p className="text-xs font-dm font-medium text-gray-600">
              Estimated runtime
              <sup className="text-seqorange text-xs font-thin cursor-help" title="This is a new feature, so accuracy might vary while we're gradually improving it">beta</sup>
            </p>
            <h4 className="text-sm font-bold text-gray-700">
              <i className={`${this.estimationIcon()} mr-1`}></i>
              {this.estimatedRuntime()}
            </h4>
          </div>
      </div>
    }
}

export default QueryStats;
